<template>
  <div class="base_box">
    <!-- 店长分红概况 -->
    <div class="base_content" style="border-radius: 0">
      <div class="base_tit" style="font-weight: 600">店长分红概况</div>
      <div class="overview_box">
        <div class="overview_item" v-for="(item, index) in overviewData" :key="index">
          <div class="overview_top">
            <img class="overview_icon" :src="item.icon" alt="" />
            <span class="overview_tit">{{ item.title }}</span>
          </div>
          <div class="overview_num">
            {{ item.value }}
            <span
              class="overview_go"
              v-if="item.go"
              @click="$router.push({ path: '/weishop/application/poolprofit/withdraw', query: { status: item.go } })"
            >
              {{ item.go == 1 ? '去审核' : '去打款' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索 -->
    <baseSearch class="mt10" @search="searchFun" @reset="resetFun" :list="searchFrom">
    </baseSearch>

    <!-- 列表 -->
    <div class="mt10 base_content" style="border-radius: 0">
      <div class="add_btn">
        <el-button type="primary" size="small" @click="addFun">添加店长</el-button>
      </div>
      <el-table :data="search.table" border stripe>
        <!-- 会员信息 -->
        <el-table-column label="会员信息" width="220">
          <template #default="{ row }">
            <div class="user_box">
              <img
                class="user_img"
                :src="row.avatar_url || require('@/static/img/people.png')"
                alt=""
              />
              <div class="user_right">
                <div>{{ row.true_name || row.nick_name || '-' }}</div>
                <div class="user_mobile">{{ row.mobile || '-' }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 申请时间 -->
        <el-table-column prop="keeper_time" label="申请时间" width="180" align="center">
          <template #default="{ row }">
            {{ row.keeper_time || '-' }}
          </template>
        </el-table-column>

        <!-- 店长余额 -->
        <el-table-column prop="keeper_balance" label="店长余额" align="center">
          <template #default="{ row }">
            {{ row.keeper_balance || '0.00' }}
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column prop="keeper_status" label="状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag v-if="row.keeper_status == 1" type="success" size="small">有效</el-tag>
            <el-tag v-else type="info" size="small">停用</el-tag>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template #default="{ row }">
            <div class="but_primary" @click="viewFun(row)">查看</div>
            <div
              v-if="row.keeper_status == 0"
              class="but_primary"
              @click="setKeeper(row, 1)"
            >设为店长</div>
            <div
              v-else
              class="but_danger"
              @click="setKeeper(row, 0)"
            >取消店长</div>
          </template>
        </el-table-column>
      </el-table>

      <div class="page_box mt10">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search.post.page"
          :page-sizes="[15, 30, 50, 100]"
          :page-size="search.post.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="search.total"
        >
        </el-pagination>
      </div>
    </div>

    <user-detail-modal :visible.sync="modalVisible" :userId="detailUserId" :poolprofitType="1" @close="modalVisible = false" />
  </div>
</template>

<script>
import baseSearch from "@/components/common/baseSearch";
import userDetailModal from "./userDetailModal";
import { eltips } from "@/util/util.js";

const overviewData = [
  { title: "累计分红总额（元）", value: "0.00", icon: require("@/static/img/weishop/application/yongjing.png") },
  { title: "累计已打款（元）", value: "0.00", icon: require("@/static/img/weishop/application/ydk.png") },
  { title: "提现中分红（元）", value: "0.00", icon: require("@/static/img/weishop/application/txz.png") },
  { title: "提现待审核（元）", value: "0.00", go: 1, icon: require("@/static/img/weishop/application/dsh.png") },
  { title: "提现待打款（元）", value: "0.00", go: 2, icon: require("@/static/img/weishop/application/ddk.png") },
  { title: "待入账分红（元）", value: "0.00", icon: require("@/static/img/weishop/application/drz.png") },
  { title: "店长人数（人）", value: "0", icon: require("@/static/img/people.png") },
];

export default {
  components: { baseSearch, userDetailModal },
  data() {
    return {
      overviewData,
      searchFrom: [
        {
          type: "input",
          Field: "nickname",
          label: "会员名称",
          placeholder: "请输入会员昵称/手机号",
        },
        {
          type: "select",
          Field: "keeper_status",
          label: "状态",
          value: -1,
          options: [
            { label: "全部", value: -1 },
            { label: "非店长", value: 0 },
            { label: "店长", value: 1 },
          ],
        },
        {
          type: "datePicker",
          Field: "created_at",
          label: "申请时间",
          style: { width: "320px" },
        },
      ],
      search: {
        post: {
          page: 1,
          limit: 15,
          nickname: "",
          mobile: "",
          keeper_status: -1,
          start_time: "",
          end_time: "",
        },
        total: 0,
        table: [],
      },
      modalVisible: false,
      detailUserId: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 搜索
    searchFun(e) {
      this.search.post = { page: 1, limit: this.search.post.limit, ...e };
      if (e.created_at && e.created_at.length == 2) {
        this.search.post.start_time = e.created_at[0];
        this.search.post.end_time = e.created_at[1];
      } else {
        this.search.post.start_time = "";
        this.search.post.end_time = "";
      }
      delete this.search.post.created_at;
      this.getList();
    },
    // 重置
    resetFun() {
      this.search.post = {
        page: 1,
        limit: 15,
        nickname: "",
        mobile: "",
        keeper_status: -1,
        start_time: "",
        end_time: "",
      };
      this.getList();
    },
    // 获取列表
    getList() {
      let params = { ...this.search.post };
      if (!params.nickname) {
        delete params.nickname;
      }
      this.axios
        .get("/api/weishop/admin/plugin/poolprofit/keeper/index", { params })
        .then((res) => {
          if (res && (res.code === 200 || res.code === 0)) {
            this.search.table = res.data.data || [];
            this.search.total = res.data.total || 0;
            this.setOverview(res.data);
          } else {
            eltips((res && res.msg) || "获取列表失败", "error");
          }
        })
        .catch(() => {
          eltips("获取列表失败", "error");
        });
    },
    // 设置概况数据
    setOverview(data) {
      const map = [
        { key: "total_bonus", title: "累计分红总额（元）" },
        { key: "paid_bonus", title: "累计已打款（元）" },
        { key: "withdrawing_bonus", title: "提现中分红（元）" },
        { key: "pending_audit_bonus", title: "提现待审核（元）", go: 1 },
        { key: "pending_pay_bonus", title: "提现待打款（元）", go: 2 },
        { key: "wait_entry_bonus", title: "待入账分红（元）" },
        { key: "total_keepers", title: "店长人数（人）" },
      ];
      this.overviewData = map.map((item) => {
        const base = overviewData.find((o) => o.title == item.title);
        return {
          ...base,
          value: data[item.key] !== undefined ? data[item.key] : base.value,
          go: item.go,
        };
      });
    },
    // 添加店长
    addFun() {
      eltips("添加店长接口待对接", "info");
    },
    // 查看
    viewFun(row) {
      this.detailUserId = row.user_id;
      this.modalVisible = true;
    },


    // 设为店长/取消店长
    setKeeper(row, status) {
      this.axios
        .post("/api/weishop/admin/plugin/poolprofit/keeper/status", {
          user_id: row.user_id,
          keeper_status: status,
        })
        .then((res) => {
          if (res && (res.code === 0 || res.code === 200)) {
            this.$set(row, "keeper_status", status);
            eltips(res.msg, "success");
            this.getList();
          } else {
            eltips((res && res.msg) || "操作失败", "error");
          }
        })
        .catch(() => {
          eltips("操作失败", "error");
        });
    },
    handleSizeChange(val) {
      this.search.post.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.post.page = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.overview_box {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}
.overview_item {
  width: 14.28%;
  min-width: 160px;
  padding: 10px 20px;
  box-sizing: border-box;
  border-right: 1px solid #f0f0f0;
  &:last-child {
    border-right: 0;
  }
}
.overview_top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.overview_icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}
.overview_tit {
  font-size: 12px;
  color: #666;
}
.overview_num {
  font-size: 22px;
  color: #000;
  font-weight: 600;
  text-align: left;
}
.overview_go {
  font-size: 12px;
  color: #006aff;
  margin-left: 6px;
  cursor: pointer;
}
.add_btn {
  padding: 15px 20px 0;
  text-align: left;
}
.user_box {
  display: flex;
  align-items: center;
}
.user_img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-right: 8px;
}
.user_right {
  text-align: left;
}
.user_mobile {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.page_box {
  text-align: right;
  padding: 15px 20px;
}
</style>
